module.exports = __webpack_public_path__ + "static/media/experience.941772bc.png";